import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
    padding: 20px 0;
`;

export const ChatPanelContainer = styled.section`
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    /* Ensure chat panel appears above any core SidePanel overlays */
    z-index: 1301;
`;
